<div class="wrapper">
<div class="authentication-reset-password d-flex align-items-center justify-content-center">
  <div class="">
    <div class="">
      <div class="card">
        <div class="row">
          <div class="col-lg-8 border-end">
            <img src="assets/images/login-images/welder.jpeg" class="card-img login-img h-100" alt="...">
          </div>
          <div class="col-lg-4">
            <div class="card-body">
              <div class="p-5">
                <div class="text-center">
                  <img src="assets/images/logo-img.png" width="180" alt="">
                </div>
                <h4 class="mt-5 font-weight-bold">Non Member Registration</h4>
                <p class="text-muted">Welcome to Kenya Association of Manufacturers Non Members Portal. Register to
                  access our services</p>
                <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                <form class="row g-3" [formGroup]="signupForm" autocomplete="off">
                  <div class="col-md-12">
                    <label for="inputFirstName" class="form-label"> Name</label>
                    <input type="text" id="inputFirstName" class="form-control" formControlName="name"
                      [ngClass]="{ 'is-invalid': f.submitted && f.name.errors }">
                    <div *ngIf="f.name.touched && f.name.invalid" class="text-danger">
                      <div *ngIf="f.name.errors?.required">First Name is required.</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label for="inputEmail" class="form-label">Email</label>
                    <input type="email" id="inputEmail" class="form-control" formControlName="emailAddress"
                      [ngClass]="{ 'is-invalid': f.submitted && f.email.errors }">
                    <div *ngIf="f.email.touched && f.emailAddress.invalid" class="text-danger">
                      <div *ngIf="f.emailAddress.errors?.required">Email is required.</div>
                      Invalid Email Address
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label for="mobilePhoneNo" class="form-label">Mobile Phone Number</label>
                    <input type="text" id="phoneNo" class="form-control" formControlName="mobilePhoneNo"
                      [ngClass]="{ 'is-invalid': f.submitted && f.mobilePhoneNo.errors }">
                    <div *ngIf="f.mobilePhoneNo.touched && f.mobilePhoneNo.invalid" class="text-danger">
                      <div *ngIf="f.mobilePhoneNo.errors?.required">Mobile Number is required.</div>
                      Check Minimum Input phone number is 10 and Maximum Number is 13
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label for="inputPassword" class="form-label">Password</label>
                    <input type="password" id="inputPassword" class="form-control" formControlName="password">
                    <div *ngIf="f.password.touched && f.password.invalid" class="text-danger">
                      <div *ngIf="f.password.errors?.required">Password is required.</div>
                      Input 8 Character Password
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label for="inputPassword" class="form-label">Repeat Password</label>
                    <input type="password" class="form-control" formControlName="passwordRepeat">
                    <div *ngIf="f.passwordRepeat.touched && f.passwordRepeat.invalid" class="text-danger">
                      <div *ngIf="f.passwordRepeat?.errors?.required">Password is required.</div>
                      <div *ngIf="f.passwordRepeat?.errors?.confirmedValidator">Password and Confirm Password must be
                        match.</div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="d-grid gap-2">
                      <button type="button" [disabled]="loading" (click)="signup()" [disabled]="!signupForm.valid"
                        class="btn btn-primary btn-lg px-5">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Register
                      </button>
                    </div>
                  </div>
                </form>
                <hr />
                <div class="col-12 text-center">
                  <a routerLink="/sign-in" class="mb-0">or sign in to your account</a>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
